/**
 * hasLocalStorage
 * indicates if localStorage is a valid feature and access has been granted
 * catches exception when localStorage access has been denied (e.g. disabled by user)
 *
 * @returns {boolean} localStorage availability and access
 */
const hasLocalStorage = () => {
  try {
    return Boolean(window.localStorage);
  } catch (e) {
    return false;
  }
};

// enable eslint when another util function has been added
// eslint-disable-next-line import/prefer-default-export
export { hasLocalStorage };
